module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deployments":"Deployments","tokens":"Tokens","integrations":"Integrations","start":"Start Here","logout":"Logout"}}')
  delete Component.options._Ctor
}
